import { useState } from 'react';
import { Drawer } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

import './EmployeeInfoContent.scss';
import EmployeeInfoContent from './EmployeeInfoContent';

/** @typedef {import('react').Dispatch<import('react').SetStateAction<boolean>>} SetEeInfoVisibility */

/**
 * Hook to wrap both component and visibility handler and reuse the component with the `EmployeeInfo`.
 * @param {EmployeeBidProfile.IDetailedEmployeeBidProfile} employeeBidProfile
 * @returns {[() => JSX.Element, SetEeInfoVisibility]}
 */
const useEmployeeInfoMobile = (employeeBidProfile) => {
    const [isEmployeeInfoOpen, setIsEmployeeInfoOpen] = useState(false);

    const EEInfoMobile = () => (
        <div className="employee-info-mobile">
            <InfoIcon onClick={() => setIsEmployeeInfoOpen(true)} />
            <Drawer
                className="ee-info-mobile-container"
                anchor="bottom"
                open={isEmployeeInfoOpen}
                onClose={() => setIsEmployeeInfoOpen(false)}
            >
                <EmployeeInfoContent
                    employeeBidProfile={employeeBidProfile}
                    isMobile
                />
            </Drawer>
        </div>
    );

    return [EEInfoMobile, setIsEmployeeInfoOpen];
};

export default useEmployeeInfoMobile;
